<div class="slInputWrap">
  @if (showUnequalOption) {
    <div class="dropdownEqualOperator">
      <his-search-select-operator
        [widget]="widget">
      </his-search-select-operator>
    </div>
  }

  <div class="dropdownEqualOperatorSibling">
    <p-autoComplete #inputElement
      [inputId]="widget.uid"
      [hisDdKey]="widget.label"
      [hisDdSearchCriterion]="true"
      [(ngModel)]="widget.value"
      [suggestions]="filteredSelectList"
      [minLength]="minLength"
      [dropdown]="showDropdownIcon"
      [forceSelection]="true"
      (completeMethod)="onUpdateInput($event)"
      (onSelect)="emitSelectedElement()"
      (onClear)="onClear()"
      optionLabel="label">

      <ng-template let-item pTemplate="item">
        {{item.label}}
      </ng-template>
    </p-autoComplete>
  </div>
</div>